import React from 'react'
import backgroundImage from '../assets/error403.png';
import { NavLink } from 'react-router-dom';

const Redirect = () => {
  return (
    <div className='flex flex-row-reverse h-screen w-full bg-skin-fill'>
    <div className=" items-center justify-center  ">
        <img src={backgroundImage} alt="ERROR 403" className="w-90 h-90 absolute top-1/2 left-1/4 transform -translate-x-1/2 -translate-y-1/2" />
    </div>
    <div className=' flex flex-col  my-60 mx-20 bg-skin-fill text-[#222224] '>
        <h1 className='text-4xl font-bold text-center mb-10 mt-6 '>We are Sorry...</h1>
        <p className='text-xl font-medium text-center px-8 '>The page you are trying to access has restricted access.</p>
        <p className='text-xl font-medium text-center px-8 '>Please refer to your system administrator.</p>
        <NavLink to='/fileuploaddetails'>
        <button className='m-60 w-28 flex p-2 rounded-xl border-1 mt-8 border-gray-100 items-center justify-center bg-skin-button text-white font-bold gap-2 active:scale-[0.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all'>Go Back</button>
        </NavLink>
    </div>
    </div>
  )
}

export default Redirect